// src/TermsOfUse.js
import React from "react";
import { Container, Typography } from "@mui/material";

function TermsOfUse() {
  return (
    <Container sx={{ py: 5 }}>
      <Typography variant="h4" gutterBottom>
        Kullanım Şartları
      </Typography>
      <Typography variant="body1" paragraph>
        Toruko, yalnızca anime severlere anime içeriklerine erişim
        sağlamayı amaçlayan bir platformdur. Tüm içeriklerimiz, genel video
        sağlayıcılarından alınmakta olup, orijinal hak sahiplerinin eserleridir.
        Toruko, telif haklarına saygı duymaktadır ve içeriğin orijinal
        sahiplerinin haklarını ihlal etmemek için çaba göstermektedir.
      </Typography>
      <Typography variant="body1" paragraph>
        Platformda bulunan anime bölümlerinin telif hakları size aitse ve
        haklarınızın ihlal edildiğini düşünüyorsanız,{" "}
        <a href="mailto:support@korsananime.com">support@korsananime.com</a>{" "}
        adresinden bizimle iletişime geçebilirsiniz. İçerikle ilgili geçerli bir
        telif hakkı bildirimi aldığımızda, bildirimde belirtilen içerik
        platformumuzdan en kısa sürede (en geç 3 iş günü içerisinde)
        kaldırılacaktır. Toruko, "uyar ve kaldır" prensibini
        benimsemektedir.
      </Typography>
      <Typography variant="body1" paragraph>
        Platformumuz, yer sağlayıcı olarak hizmet vermekte olup 5651 sayılı
        kanunun 5. maddesine uygun olarak, kullanıcıların erişimine açtığı
        içerikleri düzenleme veya kontrol etme yükümlülüğüne sahip değildir.
      </Typography>
    </Container>
  );
}

export default TermsOfUse;
